import { version } from '../../package.json'

// What identifies THIS build: the Sentry release its source maps upload under
// (next.config.ts names the same string). The Dockerfile overwrites this file
// with the commit SHA before `next build`, because an env value inlined through
// next.config `env` is not part of a module's cache key — a warm build cache
// can hand back the previous build's value. A real source change always
// recompiles. Local builds keep package.json's version.
export const buildId: string = version
